var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorUfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6989ff;stroke:#6989ff;}.cls-1,.cls-12,.cls-13,.cls-2,.cls-5{stroke-linecap:round;}.cls-1,.cls-12,.cls-13,.cls-2,.cls-4,.cls-5{stroke-linejoin:round;stroke-width:2px;}.cls-2,.cls-3{fill:#70bdfb;}.cls-2{stroke:#70bdfb;}.cls-4{fill:#5b3b63;stroke:#5b3b63;opacity:0.1;}.cls-5{fill:#cfd8dc;stroke:#cfd8dc;}.cls-6{fill:#ff927d;}.cls-7{fill:#84ff61;}.cls-8{fill:#fff35f;}.cls-9{fill:#61c5a8;}.cls-10{fill:#55a6ff;}.cls-11{fill:#f4a14e;}.cls-12{fill:#ff4931;stroke:#ff4931;}.cls-13{fill:#f2ec25;stroke:#f2ec25;}.cls-14{fill:#4f4f4f;}.cls-15{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UFO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UFO"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63,29v6c0,2.21-13.88,4-31,4S1,37.21,1,35V29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 32,
    cy: 29,
    rx: 31,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64,29c0-5-14.33-9-32-9S0,24,0,29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 32,
    cy: 26,
    rx: 20,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45,25V15A13,13,0,0,0,32,2h0A13,13,0,0,0,19,15V25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 5,
    cy: 34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 11,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 25,
    cy: 36,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 32,
    cy: 36,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 18,
    cy: 35.54,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 59,
    cy: 34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 53,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 39,
    cy: 36,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 46,
    cy: 35.54,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M40,25V16a8,8,0,0,0-8-8h0a8,8,0,0,0-8,8v9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 32,
    cy: 17,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 32,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 33,
    cy: 16,
    r: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorUfo);
export default __webpack_public_path__ + "static/media/errorUfo.5d131001f4419d40a0d59b562d8587dd.svg";
export { ForwardRef as ReactComponent };